var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 17,
    viewBox: "0 0 45 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M909.701 828.398l5.293-5.293c.181-.18.293-.43.293-.707 0-.553-.448-1-1-1-.276 0-.526.112-.707.293l-7 7c-.18.182-.293.431-.293.707 0 .276.112.526.293.707l7 7c.181.182.431.293.707.293.552 0 1-.447 1-1 0-.276-.112-.525-.293-.707l-5.293-5.293h39.586c.552 0 1-.447 1-1 0-.553-.448-1-1-1h-39.586z",
    transform: "translate(-906.000000, -821.000000) translate(928.287146, 829.398465) rotate(-180.000000) translate(-928.287146, -829.398465)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRightArrow);
export default __webpack_public_path__ + "static/media/ico-right-arrow.b0665ef0.svg";
export { ForwardRef as ReactComponent };